// extracted by mini-css-extract-plugin
export var backToTopButton = "editorial-module--backToTopButton--64e3b";
export var backToTopButtonContainer = "editorial-module--backToTopButtonContainer--c9a08";
export var blockContent = "editorial-module--blockContent--fe895";
export var blogBreadCrumbs = "editorial-module--blogBreadCrumbs--b0d79";
export var copiedText = "editorial-module--copiedText--ffded";
export var icon = "editorial-module--icon--7ad6f";
export var postBreadcrumbs = "editorial-module--postBreadcrumbs--fb804";
export var postHeadline = "editorial-module--postHeadline--ab0a9";
export var relatedContent = "editorial-module--relatedContent--acf18";
export var relatedContentGrid = "editorial-module--relatedContentGrid--ef572";
export var shareLink = "editorial-module--shareLink--85623";
export var sidebar = "editorial-module--sidebar--cbe4c";
export var sidebarStickyChildren = "editorial-module--sidebarStickyChildren--609ce";
export var socialIcons = "editorial-module--socialIcons--6f3ac";
export var styledPost = "editorial-module--styledPost--d4178";
export var tableOfContents = "editorial-module--tableOfContents--f4d8d";